import {EventEmitter} from '@angular/core';
import {Observable} from "rxjs";

//TODO: check alternative to broadcast mediator service
export class BroadcastMediatorService {
  private static events: { [event in Events]?: EventEmitter<EventEntry[event]> } = {}

  static notify<T extends Events>(event: T, data?: EventData[T]) {
    if (!this.events[event]) this.events[event] = new EventEmitter()
    this.events[event]?.emit(data)
  }

  static listen<T extends Events>(event: T): Observable<EventEntry[T]> | undefined {
    if (!this.events[event]) this.events[event] = new EventEmitter()
    return this.events[event]?.asObservable()
  }
}

type Events =
  | 'startFiltersError'
  | 'whatsappChat'
  | 'emailApp'
  | 'phoneApp'
  | 'theme'
  | 'livechat'

type EventEntry = {
  [key in Events]: EventData[key]
}

interface EventData {
  startFiltersError: void,
  whatsappChat: WhatsappChatData | undefined,
  emailApp: EmailAppData,
  phoneApp: PhoneAppData | PhoneDataContact | OtherTabPhoneStatusData;
  theme: 'dark' | 'light';
  livechat: BrowserWarningData;
}

export interface BrowserWarningData {
  action: 'showBrowserWarning';
}

export interface WhatsappChatData {
  type?: 'start' | 'invite';
  phoneNumber?: string;
}

export interface PhoneDataContact{
  phoneContact: string
}

export interface OtherTabPhoneStatusData {
  otherTabPhoneStatus: 'offline' | 'online' | 'pause' | 'ringing' | 'talking' | 'loading' | 'other_tab_online' | 'other_tab_busy';
}

export interface EmailAppData {
  type: 'new' | 'answer' | 'thread' | 'answerAll' | 'forward',
  companyId?: string,
  leadEmail?: string,
  createdAt?: string,
  threadId?: string,
  messageId?: string,
  from?: { name: string, email: string }[],
  cc?: { name: string, email: string }[],
  grantId?: string,
}

export interface PhoneAppData {
  adapter: 'code7' | 'zenvia',
  agentEmail: string,
  agentId: string | bigint,
  agentPassword: string,
  phoneExtension: number,
}
